<template>
  <div class="min-h-screen bg-slate-50 max-w-2xl mx-auto">
    <V3AppToast />
    <V3AppLoadingOverlay />
    <slot />
  </div>
</template>

<script setup lang="ts">
// layouts/v3.vue — SPEC §9. Shell only: toast + loading overlay + the page.
// Bootstrap deliberately does NOT run here (pages/v3/index.vue owns it).
import { useSessionLifecycle } from '~/composables/v3/useSessionLifecycle'

useSessionLifecycle()
</script>
